/**
 * Custom CTA Widget Tool for Editor.js
 * Creates a bordered box with centered text
 */

class CTATool {
  static get toolbox() {
    return {
      title: "CTA",
      icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="16" height="16" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
        <line x1="6" y1="10" x2="14" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <line x1="10" y1="6" x2="10" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>`,
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, api, readOnly }) {
    this.api = api;
    this.readOnly = readOnly;
    this.data = {
      text: data?.text || "CTA Section will be loaded here on Blog Page",
    };

    this.wrapper = null;
    this.textElement = null;
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("cdx-cta-widget");

    this.textElement = document.createElement("div");
    this.textElement.classList.add("cdx-cta-widget__text");
    this.textElement.contentEditable = !this.readOnly;
    this.textElement.textContent = this.data.text;
    this.textElement.dataset.placeholder = "Enter CTA text...";

    // Handle input events
    this.textElement.addEventListener("blur", () => {
      this.data.text = this.textElement.textContent;
    });

    // Handle paste events to prevent formatting
    this.textElement.addEventListener("paste", (e) => {
      e.preventDefault();
      const text = e.clipboardData.getData("text/plain");
      document.execCommand("insertText", false, text);
    });

    this.wrapper.appendChild(this.textElement);

    return this.wrapper;
  }

  save() {
    return {
      text: this.textElement.textContent || this.data.text,
    };
  }

  static get sanitize() {
    return {
      text: {},
    };
  }
}

export default CTATool;
